interface Props {}
const LocalizedVideo = (props: Props) => {
  const {} = props;
  return <div className=""></div>;
};

export default LocalizedVideo;
